import React from 'react';
import styles from './styles.module.css';
// import { technology } from '@/commonTypes';
import AppImage from '@/components/common/AppImage';
import AppLink from '@/components/common/AppLink';

export default function BadgeCard({
  item,
  mainStyle = '',
  className = '',
  href = '',
  showdot = true,
  onClick = () => {},
  extraText = '#',
  bg,
}: {
  item?: any;
  mainStyle?: string;
  className?: string;
  href?: string;
  showdot?: boolean;
  onClick?: () => void;
  extraText?: string | null;
  bg?: string;
}) {
  const renderItem = () => (
    <span
      className={`${styles.tech_pill} ${mainStyle == 'hover' && styles.hoverStyle} ${className}`}
      onClick={onClick}
      style={{ backgroundColor: bg && bg }}
    >
      {item?.fileImage?.name ? (
        <AppImage src={item?.fileImage?.name} width={40} height={40} className={`${styles.icon}`} />
      ) : (
        <>{showdot && <div className={`${styles.dot}`}></div>}</>
      )}
      {extraText}
      {item?.title}
    </span>
  );
  return (
    <>
      {href ? (
        <AppLink href={href} title={item?.title}>
          {renderItem()}
        </AppLink>
      ) : (
        <>{renderItem()}</>
      )}
    </>
  );
}
